var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2984 9.90039C8.09844 9.90039 6.39844 11.7004 6.39844 13.9004V43.3004H14.1984V13.9004C14.1984 11.7004 12.4984 9.90039 10.2984 9.90039",
    fill: "#FFDD67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2969 43.3002H39.5969V9.8002C39.5969 7.6002 37.6969 5.7002 35.4969 5.7002C33.1969 5.7002 31.3969 7.6002 31.3969 9.9002C31.2969 9.9002 31.2969 43.3002 31.2969 43.3002",
    fill: "#FFDD67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5008 5.7002C35.2008 5.7002 35.0008 5.7002 34.8008 5.8002C36.7008 6.1002 38.2008 7.8002 38.2008 9.8002V43.3002H39.7008V9.8002C39.6008 7.5002 37.7008 5.7002 35.5008 5.7002",
    fill: "#EBA352"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2016 43.2998H22.7016V9.0998C22.7016 6.6998 20.8016 4.7998 18.4016 4.7998C16.0016 4.7998 14.1016 6.6998 14.1016 9.0998L14.2016 43.2998",
    fill: "#FFDD67"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5008 4.7998C18.2008 4.7998 18.0008 4.7998 17.8008 4.8998C19.8008 5.2998 21.3008 6.9998 21.3008 9.1998V30.4998L22.8008 32.5998V9.0998C22.8008 6.6998 20.9008 4.7998 18.5008 4.7998Z",
    fill: "#EBA352"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7992 40.5H31.2992V6.3C31.2992 3.9 29.3992 2 26.9992 2C24.5992 2 22.6992 3.9 22.6992 6.3L22.7992 40.5Z",
    fill: "#FFDD67"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0008 2C26.7008 2 26.5008 2 26.3008 2.1C28.3008 2.5 29.8008 4.2 29.8008 6.4V30.5L31.3008 32.6V6.3C31.3008 3.9 29.4008 2 27.0008 2Z",
    fill: "#EBA352"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3016 9.90039C10.0016 9.90039 9.80156 9.90039 9.60156 10.0004C11.4016 10.4004 12.8016 12.0004 12.8016 13.9004V31.4004L14.3016 33.5004V13.9004C14.2016 11.7004 12.5016 9.90039 10.3016 9.90039Z",
    fill: "#EBA352"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7019 29.3003C56.1019 26.2003 51.1019 26.4003 46.0019 32.0003C42.4019 35.9003 41.7019 37.2003 38.1019 37.1003V33.0003C38.1019 33.0003 6.40187 33.1003 6.40187 35.6003C6.40187 35.6003 4.90187 46.7003 8.00187 53.7003C12.6019 64.1003 34.2019 65.7003 43.3019 48.8003C48.6019 38.8003 59.4019 32.6003 57.7019 29.3003",
    fill: "#FFDD67"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7008 29.3004C57.4008 28.7004 57.0008 28.3004 56.5008 27.9004C56.6008 28.0004 56.7008 28.1004 56.7008 28.3004C58.4008 31.7004 53.3008 35.2004 49.7008 38.8004C46.8008 41.7004 44.0008 44.7004 42.6008 48.2004C36.2008 63.5004 17.6008 63.5004 9.80078 56.5004C16.9008 64.5004 36.8008 65.2004 43.6008 49.2004C45.1008 45.7004 47.7008 42.8004 50.7008 39.8004C54.3008 36.1004 59.4008 32.6004 57.7008 29.3004",
    fill: "#EBA352"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1003 37.1001C33.2003 35.0001 21.0003 39.1001 22.6003 50.8001C22.6003 39.9001 32.5003 37.2001 37.9003 37.2001C38.6003 37.1001 39.1003 37.1001 39.1003 37.1001",
    fill: "#EBA352"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.966126c27da85b98f751d78bf9f19033.svg";
export { ForwardRef as ReactComponent };